import builder from '../builder';
import TripDestination from '../../streamline-icons/light/trip-destination.svg';

export default builder('IconTripDestinationLight', TripDestination);
